<template>
  <b-form-group :label="label" :description="description" :invalid-feedback="validationError">
    <small v-if="topDescription" class="text-muted">{{topDescription}}</small>
    <b-form-input v-model="content" @input="updateContent()" :type="type" :state="state"></b-form-input>
  </b-form-group>
</template>

<script>
export default {
  name: "TextControl",
  props: {
    label: {},
    description: {},
    topDescription: {},
    value: {
      required: true
    },
    type: {
      default: 'text'
    },
    required: {
      default: false
    },
    requiredError: {
      default: 'This field is required'
    },
    minLength: {
      default: null
    },
    minLengthError: {
      default: function () {
        return 'Please provide a value at least ' + this.minLength + ' characters long';
      }      
    },
    maxLength: {
      default: null
    },
    maxLengthError: {
      default: function () {
        return 'Please provide a value less than ' + this.maxLength + ' characters long';
      }
    },
    emailError: {
      default: 'Please provide a valid email address.'
    },
    customValidation: {},
    formName: {
      default: 'Default'
    }
  },
  data() {
    return {
      content: this.value,
      originalValue: this.value,
      state: null,
      validationError: null
    };
  },
  computed: {
    isValid: function () {
      if (this.state === null || typeof(this.customValidation) === 'function')
        this.checkValidity(this.content, this.content);

      return this.state === true || this.state === null;
    }
  },
  methods: {
    updateContent() {
      this.$emit('input', this.content);
    },
    checkValidity(newValue, oldValue) {
      let validationError = null;

      if (this.required !== null && this.required !== false && (newValue == null || newValue == ''))
        validationError = this.requiredError;
      else if (this.minLength && this.minLength > 0 && newValue.length < this.minLength)
        validationError = this.minLengthError;
      else if (this.maxLength && this.maxLength > 0 && newValue.length > this.maxLength)
        validationError = this.maxLengthError;
      else if (this.type == 'email' && !/\S+@\S+\.\S+/.test(newValue))
        validationError = this.emailError;
      else if (typeof(this.customValidation) === 'function') {
        let retVal = this.customValidation(newValue, oldValue);
        if (retVal !== true && retVal !== null)
          validationError = retVal;
        else {
          this.state = retVal;
          validationError = null;
        }
      }

      this.validationError = validationError;
      if (this.validationError != null)
        this.state = false;
      else {
        if (this.originalValue == newValue)
          this.state = null;
        else
          this.state = true;
      }
    }
  },
  watch: {
    content: function (newValue, oldValue) {
      this.checkValidity(newValue, oldValue);
    },
    value: function (newValue, oldValue) {
      this.content = newValue;
    }
  },
  mounted () {
  }
};
</script>